/*
* 菜单栏logo组件
*/

import { Image } from 'antd';
import CNF from '../incs/Config';
import LOGO from '../images/logo.png';


const XMenuLogo = (props) => {
    return (
        <div style={{ height: CNF.menuHeight, overflow: 'hidden' }}>
            <div style={{
                float: 'left',
                padding: '6px 20px 0 0',
                paddingLeft: !props.collapsed ? '20px' : '24px'
            }}>
                <Image width={30} preview={false} src={LOGO} />
            </div>
            <div style={{
                color: '#ffffff',
                lineHeight: CNF.menuHeight,
                padding: '0 20px 0 20px',
                fontSize: '15px'
            }}>{!props.collapsed ? `${CNF.projectCode} ${CNF.version}` : ''}</div>
        </div>
    );
}
export default XMenuLogo;